export const Theme = {
    colors: {
        main: '#6A451F',
        footer:{
            text: '#666',
            textHoover: '#333'
        }
    },
    buttons: {
        primary: {
            color: 'white',
            bgColor: '#6A451F',
            bgColorHoover: '#0056b3'
        },
        secondary: {
            color: '6A451F',
            bgColor: '#f8f9fa',
            bgColorHoover: '#e9ecef'
        },
        warning: {
            color: 'white',
            bgColor: '#d13819',
            bgColorHoover: '#FF0000'
        },
    }
}